import React from "react";
import styled from "styled-components";

const QuestBlog = (props) => {
  const {
    top,
    headText,
    ansTextFirst,
    ansTextSecon,
    ansTextThird,
    ansTextFour,
    ansTextFive,
    colorQuest,
  } = props;

  const spliteLink = (link, text) => {
    const newLink = link.split(text);
    return (
      <div className="link-web">
        {text}
        <a
          href="http://www.sut.ac.th/2012/phone/show_dept.php?id=1090000"
          target="_blank"
          rel="noreferrer"
        >
          <u>{newLink[1]}</u>
        </a>
      </div>
    );
  };

  const spliteText = (text) => {
    const newLink = text.split("Facebook : ");
    return (
      <div className="link-web">
        Facebook :
        <a
          href="https://www.facebook.com/dentsut/"
          target="_blank"
          rel="noreferrer"
        >
          <u>{newLink[1]}</u>
        </a>
      </div>
    );
  };

  const spliteLinkContent = (text) => {
    const newLink = text.split("|");

    return (
      <>
        {newLink[0] && spliteText(newLink[0])}
        {newLink[1] && newLink[1]} <br />
        {newLink[2] && newLink[2]}
      </>
    );
  };

  return (
    <>
      <Container top={top}>
        <QuestAnsQ color={colorQuest}>Q</QuestAnsQ>

        <TextQuest color={colorQuest}>{headText}</TextQuest>
      </Container>
      <div style={{ display: "flex", alignItems: "flex-start" }}>
        <QuestAnsA>A</QuestAnsA>
        <div>
          <TextAns>
            {headText === "อาจารย์ทันตแพทย์ และพี่ ๆ สำนัก มีใครบ้าง"
              ? spliteLink(ansTextFirst, "เข้าไปดูข้อมูลได้ที่ ")
              : headText ===
                "ติดตามข่าวสารของสำนักวิชาหรือมีช่องทางการติดต่อทางไหนบ้าง"
              ? spliteLinkContent(ansTextFirst)
              : ansTextFirst}
          </TextAns>
          {ansTextSecon && <TextAns>{ansTextSecon}</TextAns>}
          {ansTextThird && <TextAns>{ansTextThird}</TextAns>}
          {ansTextFour && <TextAns>{ansTextFour}</TextAns>}
          {ansTextFive && <TextAns>{ansTextFive}</TextAns>}
        </div>
      </div>
    </>
  );
};

export default QuestBlog;

const Container = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${(props) => (props.top ? `${props.top}px` : "20px")};

  .link-web {
    display: block;
    color: var(--black);
    word-break: break-all;

    a {
      color: var(--black);
      margin-left: 8px;

      &:hover {
        color: var(--secondary);
      }
    }
  }
`;

const TextQuest = styled.p`
  font-family: "Noto Sans Thai Bold";
  line-height: 50px;
  font-size: clamp(20px, 2.5vw, 24px);
  margin: 0;
  text-align: left;
  color: ${(props) => (props.color ? props.color : "#ea8b49")};
`;

const TextAns = styled.p`
  font-family: "Noto Sans Thai";
  line-height: 40px;
  font-size: clamp(20px, 2.5vw, 24px);
  margin: 0;
  text-align: left;

  .link-web {
    display: block;
    color: var(--black);
    word-break: break-all;

    a {
      color: var(--black);
      margin-left: 8px;

      &:hover {
        color: var(--secondary);
      }
    }
  }
`;

const QuestAnsQ = styled.p`
  font-family: "Brevia Light Italic";
  font-weight: 300;
  line-height: 60px;
  font-size: clamp(35px, 2.5vw, 60px);
  text-align: left;
  margin-right: 40px;
  margin-bottom: 0;
  color: ${(props) => (props.color ? props.color : "#ea8b49")};

  @media only screen and (max-width: 414px) {
    margin-right: 20px;
  }
`;

const QuestAnsA = styled.p`
  font-family: "Brevia Light Italic";
  font-weight: 300;
  line-height: 60px;
  font-size: clamp(35px, 2.5vw, 60px);
  text-align: left;
  margin-right: 40px;
  margin-bottom: 0;

  @media only screen and (max-width: 414px) {
    margin-right: 20px;
  }
`;
